import { connect } from 'react-redux';
import StatusBar from '../../components/block_page/StatusBar';
import { getChangedFields } from '../../selectors/smb_account_settings';
import {
  saveSettings,
  resetSettings,
} from '../../actions/smb_account_settings';

const mapStateToProps = state => {
  const fields = getChangedFields(state);
  return {
    show: Boolean(fields.length),
    saving: state.smbAccountSettings.saving,
    error: state.smbAccountSettings.errors.join(', '),
  };
};

const mapDispatchToProps = dispatch => ({
  submitAction: () => {
    dispatch(saveSettings());
  },
  cancelAction: () => {
    dispatch(resetSettings());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusBar);
